<template>
  <div class="fd-header-box">
    <div style="background: #1a81e7; height: 20px"></div>
    <div class="fd-header-banner" style="position: relative; overflow:hidden">
      <div class="fd-reset-transition" style="position: absolute; width: 975px; height: 300px; right: 2vw">
        <transition name="slide-fade" mode="out-in">
          <div v-if="showBanner === 0" class="banner0" style="position:absolute"></div>
        </transition>
        <transition name="slide-fade" mode="out-in">
          <div v-if="showBanner === 1" class="banner1" style="position:absolute"></div>
        </transition>
        <transition name="slide-fade" mode="out-in">
          <div v-if="showBanner === 2" class="banner2" style="position:absolute"></div>
        </transition>
        <transition name="slide-fade" mode="out-in">
          <div v-if="showBanner === 3" class="banner3" style="position:absolute"></div>
        </transition>
        <!-- <el-carousel
          indicator-position="none"
          style="position:fixed:top:0;right:-40px;"
          :loop="true"
          :interval="5000"
          arrow="never"
        >
          <el-carousel-item v-for="(item, index) in headerImg" :key="index">
            <div :class="'banner' + index"></div>
          </el-carousel-item>
        </el-carousel> -->
      </div>
      <img src="../assets/images/title.png" class="fd-reset-left" style="position: absolute; left: 13.3vw; bottom: 80px; z-index: 999"
        alt="" />
      <!-- <img src="../assets/qrCode/yyh.png" class="fd-reset-left" style="position: absolute;
    left: 43.3vw;
    z-index: 999;
    width: 280px;
    bottom: 10px;"
        alt="" /> -->
      <div style="
          position: absolute;
          top: 10px;
          right: 208px;
          width: 500px;
          overflow: hidden;
          z-index: 100;
        " class="fd-header-input">
        <!-- <el-col :span="5">
                        今天是{{date.dateYear}}年{{date.dateMonth}}月{{date.dateDate}}日 {{date.dateHours}}:{{date.dateMinutes}}:{{date.dateSeconds}} 星期{{date.dateDay}}
                    </el-col>
                    <el-col :span="5">
                        <span style="margin-right:5px">当前在线人数：{{zxrs}}人</span>
                        <span>总访问量：{{zfwl}}人</span>
                    </el-col> -->
        <div style="position: relative; width: 100%; right: 0">
          <i class="el-icon-search" style="
              position: absolute;
              left: 10px;
              top: 50%;
              transform: translateY(-50%);
              color: #1a73e7;
            "></i>
          <el-input v-model="inputValue" placeholder="请输入内容" style="width: 380px; margin-right:20px"></el-input>
          <el-button class="fd-serach-btn" type="primary" style="float: right; width: 100px" @click="search">搜索
          </el-button>
          <!-- <div class="fd-ewm-three1"></div> -->
        </div>
        <el-row>
          <div></div>
        </el-row>
      </div>
    </div>
    <div class="fd-home-menu">
      <el-menu router :default-active="$router.currentRoute.path" class="el-menu-demo"
        style="display: inline-block; vertical-align: top; font-family: 'PingFang SC','Hiragino','Sans GB','Microsoft YaHei UI','Microsoft YaHei','Source Han Sans CN','sans-serif'"
        mode="horizontal" @select="handleSelect">
        <el-menu-item index="/portal" style="font-size: 20px;">首页</el-menu-item>
        <el-submenu index="/xygk" class="fd-submenu">
          <template slot="title">
            <div @click="xygkClick" style="font-size: 20px;">学院概况</div>
          </template>
          <el-menu-item index="/xygk/xyjj"
            @click="handleJump(JSON.stringify(menus.xygkMenuList),'/xygk/xyjj','SYZT_XYGK_XYJJ')">学院简介</el-menu-item>
          <el-menu-item index="/xygk/syls"
            @click="handleJump(JSON.stringify(menus.xygkMenuList),'/xygk/syls','SYZT_XYGK_SYLS')">社院历史</el-menu-item>
          <el-menu-item index="/xygk/xrld"
            @click="handleJump(JSON.stringify(menus.xygkMenuList),'/xygk/xrld','SYZT_XYGK_XRLD')">现任领导</el-menu-item>
          <el-menu-item index="/xygk/xyfg"
            @click="handleJump(JSON.stringify(menus.xygkMenuList),'/xygk/xyfg','SYZT_XYGK_XYFG')">学院风光</el-menu-item>
          <el-menu-item index="/xygk/dlwz"
            @click="handleJump(JSON.stringify(menus.xygkMenuList),'/xygk/dlwz','SYZT_XYGK_DLWZ')">地理位置</el-menu-item>
        </el-submenu>
        <el-submenu index="/xwzx" class="fd-submenu">
          <template slot="title">
            <div @click="xwzxClick" style="font-size: 20px;">新闻中心</div>
          </template>
          <el-menu-item index="/xwzx/tzyw"
            @click="handleJump(JSON.stringify(menus.xwzxMenuList),'/xwzx/tzyw','SYZT_XWZX_TZYW')">统战要闻</el-menu-item>
          <el-menu-item index="/xwzx/syxw"
            @click="handleJump(JSON.stringify(menus.xwzxMenuList),'/xwzx/syxw','SYZT_XWZX_SYXW')">本院新闻</el-menu-item>
          <el-menu-item index="/xwzx/sxxw"
            @click="handleJump(JSON.stringify(menus.xwzxMenuList),'/xwzx/sxxw','SYZT_XWZX_SXXW')">市县新闻</el-menu-item>
          <el-menu-item index="/xwzx/tzgg"
            @click="handleJump(JSON.stringify(menus.xwzxMenuList),'/xwzx/tzgg','SYZT_XWZX_TZGG')">公示公告</el-menu-item>
        </el-submenu>
        <el-submenu index="/jxpx" class="fd-submenu">
          <template slot="title">
            <div @click="jxpxClick" style="font-size: 20px;">教学培训</div>
          </template>
          <el-menu-item index="/jxpx/jxxx"
            @click="handleJump(JSON.stringify(menus.jxpxMenuList),'/jxpx/jxxx','SYZT_JXPX_JXXX')">教学培训</el-menu-item>
          <el-menu-item index="/jxpx/jxyj"
            @click="handleJump(JSON.stringify(menus.jxpxMenuList),'/jxpx/jxyj','SYZT_JXPX_JXYJ')">教学研究</el-menu-item>
          <el-menu-item index="/jxpx/zzjs"
            @click="handleJump(JSON.stringify(menus.jxpxMenuList),'/jxpx/zzjs','SYZT_JXPX_ZZJS')">专职教师</el-menu-item>
          <el-menu-item index="/jxpx/jzjs"
            @click="handleJump(JSON.stringify(menus.jxpxMenuList),'/jxpx/jzjs','SYZT_JXPX_JZJS')">兼职教师</el-menu-item>
          <el-menu-item index="/jxpx/jwgl"
            @click="handleJump(JSON.stringify(menus.jxpxMenuList),'/jxpx/jwgl','SYZT_JXPX_JWGL')">教务管理</el-menu-item>
          <el-menu-item index="/jxpx/dwpx"
            @click="handleJump(JSON.stringify(menus.jxpxMenuList),'/jxpx/dwpx','SYZT_JXPX_DWPX')">对外培训</el-menu-item>
        </el-submenu>
        <el-submenu index="/kyzk" class="fd-submenu">
          <template slot="title">
            <div @click="kyzkClick" style="font-size: 20px;">科研智库</div>
          </template>
          <el-menu-item index="/kyzk/kydt"
            @click="handleJump(JSON.stringify(menus.kyzkMenuList),'/kyzk/kydt','SYZT_KYZK_KYDT')">科研动态</el-menu-item>
          <el-menu-item index="/kyzk/kygl"
            @click="handleJump(JSON.stringify(menus.kyzkMenuList),'/kyzk/kygl','SYZT_KYZK_KYGL')">科研管理</el-menu-item>
          <el-menu-item index="/kyzk/kycg"
            @click="handleJump(JSON.stringify(menus.kyzkMenuList),'/kyzk/kycg','SYZT_KYZK_KYCG')">科研成果</el-menu-item>
        </el-submenu>
        <el-submenu index="/yjdt" class="fd-submenu">
          <template slot="title">
            <div @click="tzllClick" style="font-size: 20px;">研究动态</div>
          </template>
          <!-- <el-menu-item index="/tzll/jdls"
            @click="handleJump(JSON.stringify(menus.tzllMenuList),'/tzll/jdls','SYZT_TZLL_JDLS')">经典论述1</el-menu-item>
          <el-menu-item index="/tzll/tzzc"
            @click="handleJump(JSON.stringify(menus.tzllMenuList),'/tzll/tzzc','SYZT_TZLL_TZZC')">统战政策</el-menu-item>
          <el-menu-item index="/tzll/tzwx"
            @click="handleJump(JSON.stringify(menus.tzllMenuList),'/tzll/tzwx','SYZT_TZLL_TZWX')">统战文选</el-menu-item> -->
            <el-menu-item index="/yjdt/czdjsyjzx/zxgk"
            @click="handleJump(JSON.stringify(menus.yjdtMenuList),'/yjdt/czdjsyjzx/zxgk','SYZT_CZDJSYJZX_ZXGK')">参政党建设研究中心</el-menu-item>
          <el-menu-item index="/yjdt/fgyzjjzx/zxgk"
            @click="handleJump(JSON.stringify(menus.yjdtMenuList),'/yjdt/fgyzjjzx/zxgk','SYZT_FGYZJJZX_ZXGK')">非公有制经济两个健康研究中心</el-menu-item>
          <el-menu-item index="/yjdt/mzyzjzx/zxgk"
            @click="handleJump(JSON.stringify(menus.yjdtMenuList),'/yjdt/mzyzjzx/zxgk','SYZT_MZYZJYJZX_ZXGK')">民族与宗教研究中心</el-menu-item>
            <el-menu-item index="/yjdt/zhwhzx/zxgk"
            @click="handleJump(JSON.stringify(menus.yjdtMenuList),'/yjdt/zhwhzx/zxgk','SYZT_ZHWHYJZX_ZXGK')">中华文化研究中心</el-menu-item>
        </el-submenu>
        <el-submenu index="/whjl" class="fd-submenu">
          <template slot="title">
            <div @click="whjlClick" style="font-size: 20px;">文化交流</div>
          </template>
          <el-menu-item index="/whjl/xyjj"
            @click="handleJump(JSON.stringify(menus.whjlMenuList),'/whjl/xyjj','SYZT_WHJL_XYJJ')">学院简介</el-menu-item>
          <el-menu-item index="/whjl/xydt"
            @click="handleJump(JSON.stringify(menus.whjlMenuList),'/whjl/xydt','SYZT_WHJL_XYDT')">学院动态</el-menu-item>
          <el-menu-item index="/whjl/zjwh"
            @click="handleJump(JSON.stringify(menus.whjlMenuList),'/whjl/zjwh','SYZT_WHJL_ZJWH')">浙江文化</el-menu-item>
          <el-menu-item index="/whjl/zhwh"
            @click="handleJump(JSON.stringify(menus.whjlMenuList),'/whjl/zhwh','SYZT_WHJL_ZHWH')">中华文化</el-menu-item>
        </el-submenu>
        <el-submenu index="/jgdj" class="fd-submenu">
          <template slot="title">
            <div @click="jgdjClick" style="font-size: 20px;">机关党建</div>
          </template>
          <el-menu-item index="/jgdj/djxw"
            @click="handleJump(JSON.stringify(menus.jgdjMenuList),'/jgdj/djxw','SYZT_JGDJ_DJXW')">党建新闻</el-menu-item>
        </el-submenu>
        <el-submenu index="/tsg" class="fd-submenu">
          <template slot="title">
            <div @click="tsgClick" style="font-size: 20px;">图书馆</div>
          </template>
          <el-menu-item index="/tsg/bygk"
            @click="handleJump(JSON.stringify(menus.tsgMenuList),'/tsg/bygk','SYZT_TSG_BYGK')">本院概况</el-menu-item>
          <el-menu-item index="/tsg/szzy"
            @click="handleJump(JSON.stringify(menus.tsgMenuList),'/tsg/szzy','SYZT_TSG_SZZY')">数字资源</el-menu-item>
          <el-menu-item index="/tsg/tsjs"
            @click="handleJump(JSON.stringify(menus.tsgMenuList),'/tsg/tsjs','SYZT_TSG_TSJS')">图书检索</el-menu-item>
        </el-submenu>
        <!-- <el-submenu index="/tsg" class="fd-submenu">
          <template slot="title"
            ><div style="font-size: 18px;">图书馆</div></template>
        </el-submenu> -->
        <!-- <el-menu-item style="font-size: 18px;">图书馆</el-menu-item> -->
        <!-- <el-submenu index="/yjs" class="fd-submenu">
          <template slot="title"
            ><div @click="yjsClick" style="font-size: 18px;">预决算信息</div></template
          >
          <el-menu-item
            index="/yjs/yjsxx"
            :route="{
              path: '/yjs/yjsxx',
              query: {
                menuList: JSON.stringify(menus.yjsMenuList),
                columnCode: 'yjsxxgk',
              },
            }"
          >预决算信息</el-menu-item
          >
        </el-submenu> -->
      </el-menu>
    </div>
  </div>
</template>
<script>
import router from '../router';
export default {
  data() {
    return {
      timmer: '',
      showBanner: 0,
      date: {
        dateYear: '',
        dateMonth: '',
        dateDate: '',
        dateDay: '',
        dateHours: '',
        dateMinutes: '',
        dateSeconds: '',
      },
      router,
      // zxrs:57, //在线人数
      // zfwl:114556, //总访问量
      inputValue: '', // 搜索框值
      headerImg: [
        {
          src: 'banner.png',
          title: '111',
        },
        {
          src: 'banner.png',
          title: '111',
        },
        {
          src: 'banner.png',
          title: '111',
        },
        {
          src: 'banner.png',
          title: '111',
        },
      ],
    };
  },
  watch: {
    $route: 'updataInput',
  },
  created() {
    this.timmer = setInterval(this.showBannerTimmer, 15000);
  },
  methods: {
    showBannerTimmer() {
      this.showBanner = this.showBanner > 2 ? 0 : this.showBanner + 1;
    },
    updataInput() {
      this.inputValue = '';
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    search() {
      this.$router.push({
        path: '/gtfy',
        query: {
          inputValue: this.inputValue,
        },
      });
      this.inputValue = '';
    },
    getImgUrl(src) {
      return require('../assets/images/' + src);
    },
    inputChange() {
      this.$bus.$on('inputValue', (val) => {
        this.inputValue = val;
      });
    },
    handleJump(menuList, path, columnCode) {
      localStorage.setItem('menuList', menuList);
      this.$router.push({
        path: path,
        query: {
          // menuList: JSON.stringify(this.menus.xygkMenuList),
          columnCode: columnCode,
          path:path
        },
      });
      this.$router.go(0);
    },
    xygkClick() {
      localStorage.setItem(
        'menuList',
        JSON.stringify(this.menus.xygkMenuList),
      );
      this.$router.push({
        path: '/xygk/xyjj',
        query: {
          // menuList: JSON.stringify(this.menus.xygkMenuList),
          columnCode: 'SYZT_XYGK_XYJJ',
          path: '/xygk/xyjj',
        },
      });
      this.$router.go(0);
    },
    xwzxClick() {
      debugger
      localStorage.setItem(
        'menuList',
        JSON.stringify(this.menus.xwzxMenuList),
      );
      this.$router.push({
        path: '/xwzx/tzyw',
        query: {
          // menuList: JSON.stringify(this.menus.xwzxMenuList),
          columnCode: 'SYZT_XWZX_TZYW',
          path: '/xwzx/tzyw',
        },
      });
      this.$router.go(0);
    },
    jxpxClick() {
      localStorage.setItem(
        'menuList',
        JSON.stringify(this.menus.jxpxMenuList),
      );
      this.$router.push({
        path: '/jxpx/jxxx',
        query: {
          // menuList: JSON.stringify(this.menus.jxpxMenuList),
          columnCode: 'SYZT_JXPX_JXXX',
           path: '/jxpx/jxxx',
        },
      });
      this.$router.go(0);
    },
    kyzkClick() {
      localStorage.setItem(
        'menuList',
        JSON.stringify(this.menus.kyzkMenuList),
      );
      this.$router.push({
        path: '/kyzk/kydt',
        query: {
          // menuList: JSON.stringify(this.menus.kyzkMenuList),
          columnCode: 'SYZT_KYZK_KYDT',
          path: '/kyzk/kydt',
        },
      });
      this.$router.go(0);
    },
    tzllClick() {
      //统战理论
      // localStorage.setItem(
      //   'menuList',
      //   JSON.stringify(this.menus.tzllMenuList),
      // );
      // this.$router.push({
      //   path: '/tzll/jdls',
      //   query: {
      //     // menuList: JSON.stringify(this.menus.tzllMenuList),
      //     columnCode: 'SYZT_TZLL_JDLS',
      //   },
      // });
      // this.$router.go(0);
      //研究动态
      localStorage.setItem(
        'menuList',
        JSON.stringify(this.menus.yjdtMenuList),
      );
      this.$router.push({
        path: '/yjdt/czdjsyjzx/zxgk',
        query: {
          // menuList: JSON.stringify(this.menus.tzllMenuList),
          columnCode: 'SYZT_CZDJSYJZX_ZXGK',
          path: '/yjdt/czdjsyjzx/zxgk',
        },
      });
      this.$router.go(0);
    },
    whjlClick() {
      localStorage.setItem(
        'menuList',
        JSON.stringify(this.menus.whjlMenuList),
      );
      this.$router.push({
        path: '/whjl/xyjj',
        query: {
          // menuList: JSON.stringify(this.menus.whjlMenuList),
          columnCode: 'SYZT_WHJL_XYJJ',
          path: '/whjl/xyjj',
        },
      });
      this.$router.go(0);
    },
    jgdjClick() {
      localStorage.setItem(
        'menuList',
        JSON.stringify(this.menus.jgdjMenuList),
      );
      this.$router.push({
        path: '/jgdj/djxw',
        query: {
          // menuList: JSON.stringify(this.menus.jgdjMenuList),
          columnCode: 'SYZT_JGDJ_DJXW',
          path: '/jgdj/djxw',
        },
      });
      this.$router.go(0);
    },
    tsgClick() {
      localStorage.setItem(
        'menuList',
        JSON.stringify(this.menus.tsgMenuList),
      );
      this.$router.push({
        path: '/tsg/bygk',
        query: {
          // menuList: JSON.stringify(this.menus.tsgMenuList),
          columnCode: 'SYZT_TSG_BYGK',
          path: '/tsg/bygk',
        },
      });
      this.$router.go(0);
    },
    // yjsClick() {
    //   this.$router.push({
    //     path: "/yjs/yjsxx",
    //     query: {
    //       menuList: JSON.stringify(this.menus.yjsMenuList),
    //       columnCode: "yjsxxgk",
    //     },
    //   });
    //   this.$router.go(0);
    // }
  },
  mounted: function () {
    this.inputChange();
    // this.getDateTime();
    // console.log(this.$router.currentRoute.path, '$router.path')
  },
};
</script>
<style scoped>
.fd-header-box {
  height: 100%;
  background: #1a81e7;
}
.fd-header-banner {
  height: 300px;
  background: url('../assets/images/bg.png') 67%;
}
.fd-home-menu {
  width: 100%;
  margin: 0 auto;
}
.banner0 {
  width: 100%;
  height: 100%;
  background: url('../assets/images/banner/01.png') 30% 60%;
}

.banner1 {
  width: 100%;
  height: 100%;
  background: url('../assets/images/banner/02.png') 30% 60%;
}
.banner2 {
  width: 100%;
  height: 100%;
  background: url('../assets/images/banner/03.png') 30% 60%;
}
.banner3 {
  width: 100%;
  height: 100%;
  background: url('../assets/images/banner/04.png') 30% 60%;
}

.fd-ewm-three1 {
  background: url('../assets/qrCode/yyh.png') no-repeat;
  background-size: 100%;
  width: 290px;
  height: 20vw;
  margin-left: 50px;
  position: relative;
  top: -40px;
}
</style>
<style>
.fd-header-input .el-input__inner {
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding-left: 30px;
}
.fd-header-input .el-input__inner::-webkit-input-placeholder {
  color: #999;
  margin-left: 10px;
}
/* el-menu样式重置 */
.fd-header-box .el-menu-item {
  padding: 0 2vw;
}
.fd-header-box .el-submenu__title {
  padding: 0 2vw;
}
.fd-header-box .el-menu.el-menu--horizontal {
  border: none;
}
.fd-header-box .el-menu {
  background: transparent;
}
.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background: transparent;
}
.fd-header-box .el-menu--horizontal > .el-menu-item {
  color: #fff;
  border: none;
}
.fd-header-box .el-menu--horizontal > .el-submenu .el-submenu__title {
  color: #fff;
  border: none;
}
.fd-header-box .el-submenu__title i {
  color: #fff;
}
.fd-header-box .is-active {
  background: rgba(255, 255, 255, 0.2) !important;
}

.fd-header-box .el-menu--horizontal > .el-menu-item.is-active {
  border: none !important;
  background: rgba(24, 128, 255, 0.1) !important;
}
.fd-header-box .el-menu-item {
  color: #fff !important;
}
.fd-header-box .el-menu--horizontal > .el-menu-item:hover {
  background: rgba(255, 255, 255, 0.2) !important;
}
.fd-header-box .el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  color: #303134;
}
.fd-header-box
  .el-menu--popup-bottom-start
  .el-menu-item:not(.is-disabled):focus,
.el-menu--popup-bottom-start .el-menu-item:not(.is-disabled):hover {
  /* background: #1a73e7 !important; */
  color: #303133 !important;
}
.fd-header-box .el-menu-demo .el-menu-item:not(.is-disabled):focus,
.el-menu-demo .el-menu-item:not(.is-disabled):hover {
  background: rgba(24, 128, 255, 0.1);
  color: #fff;
}
.fd-header-box .el-menu--popup {
  padding: 0;
}
.fd-header-box .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border: none;
}
.fd-header-box .el-submenu__icon-arrow {
  display: none;
}
.fd-header-box .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.fd-header-box .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  color: #fff !important;
}
.fd-header-box .el-submenu__title:focus {
  background: rgba(255, 255, 255, 0.2);
}

.slide-fade-enter-active {
  transition: all 8s ease;
}
.slide-fade-leave-active {
  transition: all 5s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter {
  transform: translateX(100px);
  opacity: 0;
}
.slide-fade-leave-to {
  transform: translateX(-100px);
  opacity: 0;
}
/* .fd-home-menu {
  width: 1420px !important;
  margin: 0 auto !important;
} */
.fd-serach-btn {
  font-size: 16px;
  padding: 11px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue